import { type PayloadAction, createSlice } from "@reduxjs/toolkit"
import {
  IGameplayEvent,
  IGameplayStateResponse
} from "@/store/apis/gameplayAPI"
import type { IGameplaySliceState } from "."

interface IGameDerivedState {
  isMatchActive: boolean
  isMatchFinished: boolean
  isMyTurn: boolean
  isWinner: boolean
  isTonMatch: boolean
}

export const initialState: IGameplaySliceState = {
  events: [],
  isEventFulfilled: false,
  sessionId: undefined,
  prevState: undefined,
  isSocketConnected: false,
  isMatchActive: false,
  isMatchFinished: false,
  isMyTurn: false,
  isWinner: false,
  isTonMatch: false,
  lastStateReceivedAt: 0,
  isConnectionOverlayVisible: false
}

export const GameplaySlice = createSlice({
  name: "gameplay",
  initialState,
  reducers: {
    addEvent: (state, { payload }: PayloadAction<IGameplayEvent>) => {
      state.events.push(payload)
    },
    setEventFulfilled: (state, { payload }: PayloadAction<boolean>) => {
      state.isEventFulfilled = payload
    },
    setEvents: (state, { payload }: PayloadAction<IGameplayEvent[]>) => {
      state.events = payload
    },
    setSessionId: (state, { payload }: PayloadAction<string | undefined>) => {
      state.sessionId = payload
    },
    setPrevState: (
      state,
      { payload }: PayloadAction<IGameplayStateResponse | undefined>
    ) => {
      state.prevState = payload
    },
    clearGameplayState: () => {
      return initialState
    },
    setIsSocketConnected: (state, { payload }: PayloadAction<boolean>) => {
      state.isSocketConnected = payload
    },
    setGameDerivedState: (
      state,
      { payload }: PayloadAction<IGameDerivedState>
    ) => {
      state.isMatchActive = payload.isMatchActive
      state.isMatchFinished = payload.isMatchFinished
      state.isMyTurn = payload.isMyTurn
      state.isWinner = payload.isWinner
      state.isTonMatch = payload.isTonMatch
    },
    setLastStateReceivedAt: (state, { payload }: PayloadAction<number>) => {
      state.lastStateReceivedAt = payload
    },
    setConnectionOverlay: (state, { payload }: PayloadAction<boolean>) => {
      state.isConnectionOverlayVisible = payload
    }
  }
})

export const {
  addEvent,
  setEventFulfilled,
  setEvents,
  setSessionId,
  setPrevState,
  clearGameplayState,
  setIsSocketConnected,
  setGameDerivedState,
  setLastStateReceivedAt,
  setConnectionOverlay
} = GameplaySlice.actions
